<style lang="scss" scoped>
.look_g {
	display: inline-block;
	width: 1px;
	height: 18px;
	margin-right: .5rem;
	border-left: 4px solid#0c8b97;
}
.sp_content{
	background:#fafafa;
	padding: 10px;
	font-size: 0.8rem;
}

</style>
<template>
	<div id='warp_subs' style="padding: 20px;">
		<div style="display: flex;align-items: center;">
			<div class="look_g"></div>
			<span style="color:#0c8b97;font-size:0.9rem">審批詳情</span>
		</div>
		<div style="height:450px;overflow-y: auto;margin-top: 15px;">
			<div class="sp_content">
				<div style="border-bottom: 2px solid #e5e5e5 ;padding: 10px 0;" v-for="(item,index) in dataList" :key="index" :style="dataList.lenght == index-1 ?'border:none':''">
					<div>
						<span>{{item.realname}} {{item.position}}</span>
						<span style="float: right;">{{item.createtime}}</span>
					</div>
					<div style="margin-top: 5px;">{{item.status}}</div>
				</div>

			</div>
		</div>
	</div>
</template>
<script>
import App from '@/assets/app.js';
	export default {
		props: ['isopen','forms'],
		components: {
			
		},
		data() {
			return {
				ipoAduitAdmin: this.$store.state.rolesdata.indexOf('ipoAduitAdmin') >= 0,
				ipoAdmin: this.$store.state.rolesdata.indexOf('ipoAdmin') >= 0,
				dataList:[],
				
			}
		},
		created(){
		},
		mounted() {
			this.getUsMarketAuditLogWithUsStockid()
		},
		methods:{
			getUsMarketAuditLogWithUsStockid(){
				this.$ajax({
					method:'post',
					url:this.$api.getUsMarketAuditLogWithUsStockid,
					data:{
						usstockid:this.forms.usstockid,
					}
				}).then(res=>{
					if(res.data.qmiscode === 1000){
						this.dataList = res.data.UsMarketAuditLogList
					}else{
						App.oTool.warningT(res.data.qmismsg)
					}
				})
			}
		}
	}
</script>

<style>
</style>
